module.exports = __webpack_public_path__ + "img/newspic1.5acb855a.png";